import React, { useState } from "react";
import Modal from "react-modal";
import ModalClose from "shared/ui/svg-icons/Leaderboard/Mobile/ModalClose";

const LeaderboardModal = ({ data, modalOpen, closeModal }) => {
  const customStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.7)",
    },
    content: {
      inset: "70% 0px 0px",
      borderTopLeftRadius: "20px",
      borderTopRightRadius: "20px",
    },
  };

  return (
    <Modal
      isOpen={modalOpen}
      onRequestClose={closeModal}
      style={customStyles}
      ariaHideApp={false}
      contentLabel="Example Modal">
      <div>
        <span className="modal-close-trigger" onClick={closeModal}>
          <ModalClose />
        </span>
        <div>
          <div className="modal-leader-about">About</div>
          <div className="modal-leader-title">{data.title}</div>
          <div className="modal-leader-about">{data.subtitle}</div>
        </div>
      </div>
    </Modal>
  );
};

export default LeaderboardModal;
